import { CommonModule } from '@angular/common';
import { Component, OnInit, ChangeDetectionStrategy, Input } from '@angular/core';
// import { DayAgoPipe } from 'libs/shared/src/lib/filters/dayago.pipe';
// import { TimeLinePipeModule } from 'libs/shared/src/lib/filters/timeline.pipe';
// import { reduceRight } from 'lodash';
import { BehaviorSubject } from 'rxjs';

import {
  TranslateModule,
  TranslateService,
} from '@ngx-translate/core';
// import { FactoryHttpLoader } from '@fitness-force/shared';

@Component({
  selector: 'plan-frequency',
  templateUrl: './plan-frequency.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    CommonModule,
    TranslateModule
]
})
export class PlanFrequencyComponent implements OnInit {
  @Input() columnData = new BehaviorSubject(null);
  @Input() additionData = new BehaviorSubject(null);
  frequency = "";
  constructor(
    public translate: TranslateService
  ) { }


  ngOnInit(): void {
    this.columnData.subscribe((cols: any) => {
      //  this.frequency=cols.billing_interval_type
      if (cols.billing_interval_value == 0) {
        this.frequency = "";
      }
      else if (cols.billing_interval_type == "Week") {
        if (cols.billing_interval_value == 1) {
          this.translate.get('common.PERIOD.WEEKLY')
            .subscribe((translations) => {
              this.frequency = translations;
            });
        } else if (cols.billing_interval_value == 2) {
          this.translate.get('common.PERIOD.BIWEEKLY')
            .subscribe((translations) => {
              this.frequency = translations;
            });
        } else if (cols.billing_interval_value == 3) {
          this.translate.get('common.PERIOD.3WEEKS')
            .subscribe((translations) => {
              this.frequency = translations;
            });
        } else if (cols.billing_interval_value == 4) {
          this.translate.get('common.PERIOD.MONTHLY')
            .subscribe((translations) => {
              this.frequency = translations;
            });
        } else if (cols.billing_interval_value > 4 && cols.billing_interval_value <= 12) {
          this.translate.get('common.PERIOD.WEEKS')
            .subscribe((translations) => {
              this.frequency = cols.billing_interval_value + " x " + translations;
            });
        } else if (cols.billing_interval_value == 13) {
          this.translate.get('common.PERIOD.QUARTERLY')
            .subscribe((translations) => {
              this.frequency = translations;
            });
        } else if (cols.billing_interval_value == 26) {
          this.translate.get('common.PERIOD.HALFYEARLY')
            .subscribe((translations) => {
              this.frequency = translations;
            });
        } else if (cols.billing_interval_value == 52) {
          this.translate.get('common.PERIOD.YEARLY')
            .subscribe((translations) => {
              this.frequency = translations;
            });
        } else {
          this.translate.get('common.PERIOD.WEEKS')
            .subscribe((translations) => {
              this.frequency = cols.billing_interval_value + " x " + translations;
            });
        }
      } else if (cols.billing_interval_type == "Month") {
        if (cols.billing_interval_value == 1) {
          this.translate.get('common.PERIOD.MONTHLY')
            .subscribe((translations) => {
              this.frequency = translations;
            });
        } else if (cols.billing_interval_value == 2) {
          this.translate.get('common.PERIOD.BIMONTHLY')
            .subscribe((translations) => {
              this.frequency = translations;
            });
        } else if (cols.billing_interval_value == 3) {
          this.translate.get('common.PERIOD.QUARTERLY')
            .subscribe((translations) => {
              this.frequency = translations;
            });
        } else if (cols.billing_interval_value == 6) {
          this.translate.get('common.PERIOD.HALFYEARLY')
            .subscribe((translations) => {
              this.frequency = translations;
            });
        }
        else if (cols.billing_interval_value == 12) {
          this.translate.get('common.PERIOD.YEARLY').subscribe((translations) => {
            this.frequency = translations;
          });
        }
        else //if(cols.billing_interval_value==12)
        {
          this.translate.get('common.PERIOD.MONTH')
            .subscribe((translations) => {
              this.frequency = cols.billing_interval_value + " " + translations;
            });
        }
      } else if (cols.billing_interval_type == "Day") {
        if (cols.billing_interval_value == 1) {
          this.translate.get('common.PERIOD.DAY')
            .subscribe((translations) => {
              this.frequency = "1 " + translations;
            });

        } else {
          this.translate.get('common.PERIOD.DAYS')
            .subscribe((translations) => {
              this.frequency = cols.billing_interval_value + " x " + translations;
            });
        }
      }
    })
  }
}
